import type { CommandContext } from '@commands';

import type { ScriptingContext } from './ScriptingContext';

// This is the base class for all scripting API objects. It provides access to
// the command context, which is the object that APIs use to interact with
// the rest of the app.
export abstract class ScriptingAPI {
  #scriptingContext: ScriptingContext;

  constructor(context: ScriptingContext) {
    this.#scriptingContext = context;
  }

  protected get commandContext(): CommandContext {
    return this.#scriptingContext.commandContext;
  }
}
